import { TableCell, Typography, Icon } from "@mui/material";
import { FC } from "react";
import { RiSparkling2Fill } from "react-icons/ri";

import { IKmosV2AllocationView, KmosAllocationType } from "../../../logic/api";
import { getTimeSlotDateStateColours } from "./KmosView";

const KmosTimeSlotCell: FC<{
  openDialog: () => void;
  setSelectedTsv: (tsv: IKmosV2AllocationView) => void;
  tsView: IKmosV2AllocationView;
}> = ({
  openDialog,
  setSelectedTsv,
  tsView
}) => {
    const due = tsView.total.dueIn || 0;
    const capacity = tsView.total.capacity || 0;
    const current = tsView.total.current || 0;
    const spaces = capacity - current;
    const [, , className] = getTimeSlotDateStateColours(
      spaces,
      due,
      tsView.total.capacity !== null
    );

    return (
      <TableCell
        align="center"
        className={className}
        padding="none"
        onClick={() => {
          setSelectedTsv(tsView);
          openDialog();
        }}
        sx={{
          cursor: 'pointer',
          border: '2px solid white',
          position: 'relative',
        }}
      >
        {tsView.hasSuggestions && (
          <Icon
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <RiSparkling2Fill color="white" size={16} />
          </Icon>
        )}
        <Typography>{due} / {spaces}</Typography>
      </TableCell>
    );
  };

export default KmosTimeSlotCell;
